import styled from 'styled-components';

export const Arrow = styled.span`
  ${({ direction, color = 'rgb(0,0,50)' }) => `
    width: 9px;
    height: 9px;
    display: inline-block;
    border-top: 2px solid ${color};
    border-right: 2px solid ${color};
    transform: rotate(${direction === 'left' ? '-135deg' : '45deg'});
  `}
`;
